import { KpiCard } from '@/components/cards/kpi-card'
import { PeriodFilter } from '@/components/filters/period'
import { PageContent } from '@/components/layout/page-content'
import { PageHeader } from '@/components/layout/page-header'
import { PageLayout } from '@/components/layout/page-layout'
import { TableInfo } from '@/components/tables/table'
import { PageSubtitle } from '@/components/titles/page-subtitle'
import { ROUTES } from '@/constants/routes'
import type { Request } from '@/types/requests/request'
import { useMyReviews } from './hooks/use-my-reviews'

export const MyReviewsPage = () => {
  const {
    states: {
      requestData,
      requestIsLoading,
      kpiStartDate,
      kpiEndDate,
      externalTransferKpiData,
      changeOfMajorKpiData,
      creditTransferKpiData,
      isRefetchingKpis,
      pageIsLoading,
      requestIsFetching
    },
    actions: { createTable, setKpiEndDate, setKpiStartDate, refetchKpis }
  } = useMyReviews()

  const tableConfig = createTable(requestData?.data)

  return (
    <PageLayout>
      <PageHeader title="Minhas Análises" />

      <PageContent>
        <div className="flex justify-between items-center mb-4">
          <PageSubtitle>Tipos de Solicitações</PageSubtitle>
          <div>
            <PeriodFilter
              startDate={kpiStartDate}
              endDate={kpiEndDate}
              setStartDate={setKpiStartDate}
              setEndDate={setKpiEndDate}
              applyFilter={() => {
                refetchKpis()
              }}
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-4">
          <KpiCard
            cardTitle="Troca de Curso"
            data={changeOfMajorKpiData}
            redirectTo={ROUTES.MY_REVIEWS_CHANGE_OF_MAJOR.route}
            isLoading={isRefetchingKpis || pageIsLoading}
            greenLabel="Em Dia"
            orangeLabel="Vencendo"
            redLabel="Em Atraso"
          />
          <KpiCard
            cardTitle="Aproveitamento de Estudo"
            data={creditTransferKpiData}
            redirectTo={ROUTES.MY_REVIEWS_CREDIT_TRANSFER.route}
            isLoading={isRefetchingKpis || pageIsLoading}
            greenLabel="Em Dia"
            orangeLabel="Vencendo"
            redLabel="Em Atraso"
          />
          <KpiCard
            cardTitle="Transferência Externa"
            data={externalTransferKpiData}
            redirectTo={ROUTES.MY_REVIEWS_EXTERNAL_TRANSFER.route}
            isLoading={isRefetchingKpis || pageIsLoading}
            greenLabel="Em Dia"
            orangeLabel="Vencendo"
            redLabel="Em Atraso"
          />
        </div>

        <div className="w-full mt-16">
          <TableInfo<Request>
            tableConfig={tableConfig}
            completeListRoutToRedirect={ROUTES.MY_REVIEWS_GENERAL_REVIEWS.route}
            tableTitle="Últimas Solicitações"
            withFilters={false}
            isLoading={requestIsLoading || pageIsLoading}
            isFetching={requestIsFetching}
          />
        </div>
      </PageContent>
    </PageLayout>
  )
}
